<div class="wrapper">
  <div class="header-section flex justify-start items-start gap-[32px]">

    @for (header of headersList; track header) {
      <div
        (click)="selectHeader(header)"
        [class.selected]="selectedTabId === header?.id"
        class="header text-type-3 cursor-pointer text-[#60698B]"
        >
        {{ header.label }}
      </div>
    }
  </div>


  <div class="content-section">
    @switch (selectedTabId) {
      @case (0) {
        <app-submittals-list
          class="tab-content"
          />
      }
      @case (1) {
        <app-submittals-registry
          class="tab-content"
          />
      }
    }
  </div>
</div>
